import React, { useState, useEffect } from 'react';
import ExpandableBox from '../../partials/ExpandableBox/ExpandableBox.js'
import SpeechBubble from './SpeechBubble.svg'

const MainDropDown = props => {
    const [displayContent, setDisplayContent] = useState(false)

    function switchDisplay() {
        setDisplayContent(!displayContent)
    }
    return(
        <div className={`MainDropDown `}>
            <div className={`main-top-section ${props.checked&& "checked"} ${displayContent&& "display"}`} onClick={switchDisplay}>
                <div className={`main-button-container`}>
                    <div className="main-expand-toggle">{displayContent ? "-" : "+"}</div>
                </div>
                <div className={`industry-and-message`}>
                    <div className={`industry-and-message-second-checkbox-container`}>
                        <h3>{props.data.header}</h3>
                        {props.checked &&
                            <div className="check-container dropdown-check">
                                <input className={`secondary-checkbox`} type="checkbox" checked={true} />
                                <span className="checkmark"></span>
                            </div>
                        }
                        
                    </div>
                    <div>
                        {/* <div onClick={() => props.setCurrentItemInfo([props.index, -1])} className={`main-message-icon`}><img src={SpeechBubble} alt="Speech Bubble" /></div> */}
                    </div>
                </div>
            </div>
            <div className={`ExpandableBox-container`}>
                {
                    props.data.subCapabilities.map((e,i) => {
                        return <ExpandableBox display={displayContent} showAudio={props.showAudio} index={i} parentIndex={props.index} data={e} setCurrentItemInfo={props.setCurrentItemInfo} checked={props.clickedCheckboxes[props.index][i+1]}/>
                    })
                }
            </div>
        </div>
    )
}

export default MainDropDown